import PropTypes from "prop-types";
import React from "react";

import AcceptResponseConfirmationMessage from "./messages/AcceptResponseConfirmationMessage";
import AutoResponseConfirmationMessage from "./messages/AutoResponseConfirmationMessage";
import MarkAsResolvedMessage from "./messages/MarkAsResolvedMessage";

import MessageType from "../../constants/ChatMessageTypes";

class ConfirmationMessageContainer extends React.Component {
    render() {
        const { messageType, response } = this.props;

        switch (messageType) {
            case MessageType.AcceptResponseConfirmationMessage:
                return <AcceptResponseConfirmationMessage recognitionRecipient={response.recognitionRecipient} />;
            case MessageType.AutoResponseConfirmationMessage:
                return (
                    <AutoResponseConfirmationMessage
                        showChatbotNameAndAvatar={response.showChatbotNameAndAvatar}
                        recognitionRecipient={response.recognitionRecipient}
                    />
                );
            case MessageType.MarkAsResolvedMessage:
                return <MarkAsResolvedMessage recognitionRecipient={response.recognitionRecipient} />;
            default:
                return null;
        }
    }
}

ConfirmationMessageContainer.propTypes = {
    messageType: PropTypes.oneOf([
        MessageType.AcceptResponseConfirmationMessage,
        MessageType.AutoResponseConfirmationMessage,
        MessageType.MarkAsResolvedMessage,
    ]),
    response: PropTypes.object.isRequired,
};

export default ConfirmationMessageContainer;
